module.exports = " <div class=swiper-container> <slot name=parallax-bg></slot> <div :class=defaultSwiperClasses.wrapperClass> <slot></slot> </div> <slot name=pagination></slot> <slot name=button-prev></slot> <slot name=button-next></slot> <slot name=scrollbar></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-awesome-swiper/src/swiper.vue
// module id = 392
// module chunks = 31